import { lazy, Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { AppHeader } from './AppHeader'
import { useAppShell } from './useAppShell'

const QuickDepositModal = lazy(() => import('@/platform/wallet/deposit/QuickDepositModal')
  .then(module => ({ default: module.QuickDepositModal })))
const GoogleDriveConsentCoordinator = lazy(() => import('@/platform/google-drive/ui/GoogleDriveConsentCoordinator')
  .then(module => ({ default: module.GoogleDriveConsentCoordinator })))

export function AppLayout() {
  const shell = useAppShell()
  return <div className="flex min-h-dvh flex-col bg-slate-50">
    <AppHeader
      authenticated={shell.authenticated}
      logoutBusy={shell.logoutBusy}
      wallet={shell.wallet}
      walletLoading={shell.walletLoading}
      onDeposit={shell.openDeposit}
      onLogin={shell.login}
      onLogout={() => void shell.logout()}
    />
    <div className="min-h-0 flex-1"><Outlet /></div>
    <Suspense fallback={null}>{shell.depositOpen && <QuickDepositModal
      isOpen
      initialTab="deposit"
      walletSummary={shell.wallet}
      refetchStats={shell.refreshWallet}
      onClose={shell.closeDeposit}
    />}</Suspense>
    <Suspense fallback={null}>{shell.googleDriveConsentOpen && <GoogleDriveConsentCoordinator />}</Suspense>
  </div>
}
